import { randomTitle, RandomGenerator } from '..';
var RoleInfoBuilder = /** @class */ (function () {
    function RoleInfoBuilder() {
        this.role = {
            id: 'b0bb0b0b-b0b0-b0b0-b0b0-b0bb0bb0bb0b',
            name: 'My Test Role',
            editable: true,
            creationDate: 10,
            lastUpdateDate: 20,
            agentsCount: 0
        };
    }
    RoleInfoBuilder.prototype.withId = function (id) {
        this.role.id = id;
        return this;
    };
    RoleInfoBuilder.prototype.withName = function (name) {
        this.role.name = name;
        return this;
    };
    RoleInfoBuilder.prototype.withDescription = function (description) {
        this.role.description = description;
        return this;
    };
    RoleInfoBuilder.prototype.withEditable = function (editable) {
        this.role.editable = editable;
        return this;
    };
    RoleInfoBuilder.prototype.withCreationDate = function (creationDate) {
        this.role.creationDate = creationDate;
        return this;
    };
    RoleInfoBuilder.prototype.withLastUpdateDataDate = function (lastUpdateDate) {
        this.role.lastUpdateDate = lastUpdateDate;
        return this;
    };
    RoleInfoBuilder.prototype.withAgentsCount = function (agentsCount) {
        this.role.agentsCount = agentsCount;
        return this;
    };
    RoleInfoBuilder.prototype.build = function () {
        return this.role;
    };
    RoleInfoBuilder.prototype.generateRandomList = function (num) {
        return randomTitle(num)
            .map(function (name) { return new RoleInfoBuilder()
            .withName(name)
            .withId(RandomGenerator.randomId())
            .build(); });
    };
    return RoleInfoBuilder;
}());
export { RoleInfoBuilder };
//# sourceMappingURL=roles-info.builder.js.map